module.exports = __webpack_public_path__ + "static/media/Linkedin.cba4cccc.svg";